import React, { Component } from 'react';
import SpecialityProducts from "../blocks/SpecialityProducts/index.js";
import LifeInsurance from '../blocks/LifeInsurance.js';
import DeathDismemberment from '../blocks/DeathDismemberment.js';
import DependentLife from '../blocks/DependentLife.js';
import STD from '../blocks/STD.js';
import LTD from '../blocks/LTD.js';
import CriticalIllness from '../blocks/CriticalIllness.js';
import Drugs from '../blocks/Drugs.js';
import Healthcare from '../blocks/Healthcare.js';
import Dental from '../blocks/Dental.js';
import SpendingAccounts from '../blocks/SpendingAccounts.js';
import EFAP from '../blocks/EFAP.js';
import VirtualHealthcare from '../blocks/VirtualHealthcare.js';
import FinancialAwareness from '../blocks/FinancialAwareness.js';
import Text from '../../../components/Text.js';
import OutOfCountry from '../blocks/OutOfCountry.js';
class ModularFlexForm extends Component {
  render() {
    const {
      blueprint,
      errors,
      isMasterSite,
      saveModularBenefitInitData,
      saveModularField,
      whitelabel,
      setChangesMadeFlag
    } = this.props;
    const styles = {
      tierBlock: {
        // border: "2px solid #F1F1F1",
        borderRadius: "5px",
        padding: "30px",
        marginTop: "10px",
        marginBottom: "10px"
      },
      tireBlockTitle: {
        display: 'flex',
        flex: 1,
        flexDirection: 'row',
        alignItems: 'center'
      },
      tierNumberCircle: {
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        width: "30px",
        height: "30px",
        borderRadius: "30px",
        marginRight: "10px"
      }
    };
    this._specialityProductsBlock = /*#__PURE__*/React.createElement(SpecialityProducts, {
      type: "modular",
      classID: this.props.classID,
      specialityProductMetaConfigs: this.props.specialityProductMetaConfigs,
      specialityProducts: blueprint.specialityProducts,
      errors: errors ? errors.specialityProducts : {},
      isMasterSite: isMasterSite,
      saveModularBenefitInitData: saveModularBenefitInitData,
      saveModularField: saveModularField,
      whitelabel: whitelabel,
      setChangesMadeFlag: setChangesMadeFlag
    });
    if (this.props.accountMeta.isPrivateLabel && (this.props.isPrivateLabelAdvisor || this.props.isMasterSite)) {
      return this._specialityProductsBlock;
    }
    return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("div", {
      style: {
        backgroundColor: '#FDF6EA',
        border: "2px solid #F9D7A2",
        ...styles.tierBlock
      }
    }, /*#__PURE__*/React.createElement("div", {
      style: styles.tireBlockTitle
    }, /*#__PURE__*/React.createElement("div", {
      style: {
        backgroundColor: '#F4AF47',
        ...styles.tierNumberCircle
      }
    }, /*#__PURE__*/React.createElement(Text, {
      bold: true,
      medium: true,
      color: "#FFFFFF"
    }, "1")), /*#__PURE__*/React.createElement(Text, {
      bold: true,
      large: true
    }, "Gold Tier")), /*#__PURE__*/React.createElement(Healthcare, {
      type: "modular",
      tier: "gold",
      lightTierColor: "#FFEDCE",
      darkTierColor: "#F4AF47",
      classID: this.props.classID,
      data: blueprint.health.gold.healthcare,
      errors: errors ? errors.health.gold.healthcare : {},
      isMasterSite: isMasterSite,
      saveModularBenefitInitData: saveModularBenefitInitData,
      saveModularField: saveModularField,
      whitelabel: whitelabel,
      setChangesMadeFlag: setChangesMadeFlag
    }), /*#__PURE__*/React.createElement(Drugs, {
      type: "modular",
      tier: "gold",
      lightTierColor: "#FFEDCE",
      darkTierColor: "#F4AF47",
      classID: this.props.classID,
      data: blueprint.health.gold.drugs,
      errors: errors ? errors.health.gold.drugs : {},
      isMasterSite: isMasterSite,
      saveModularBenefitInitData: saveModularBenefitInitData,
      saveModularField: saveModularField,
      whitelabel: whitelabel,
      setChangesMadeFlag: setChangesMadeFlag
    }), /*#__PURE__*/React.createElement(Dental, {
      type: "modular",
      tier: "gold",
      lightTierColor: "#FFEDCE",
      darkTierColor: "#F4AF47",
      classID: this.props.classID,
      data: blueprint.dental.gold,
      errors: errors ? errors.dental.gold : {},
      isMasterSite: isMasterSite,
      saveModularBenefitInitData: saveModularBenefitInitData,
      saveModularField: saveModularField,
      whitelabel: whitelabel,
      setChangesMadeFlag: setChangesMadeFlag
    }), /*#__PURE__*/React.createElement(SpendingAccounts, {
      type: "modular",
      tier: "gold",
      lightTierColor: "#FFEDCE",
      darkTierColor: "#F4AF47",
      classID: this.props.classID,
      data: blueprint.health.gold.spendingAccounts,
      errors: errors ? errors.health.gold.spendingAccounts : {},
      isMasterSite: isMasterSite,
      saveModularBenefitInitData: saveModularBenefitInitData,
      saveModularField: saveModularField,
      whitelabel: whitelabel,
      setChangesMadeFlag: setChangesMadeFlag
    })), /*#__PURE__*/React.createElement("div", {
      style: {
        backgroundColor: '#F4F6F8',
        border: "2px solid #C7CCD6",
        ...styles.tierBlock
      }
    }, /*#__PURE__*/React.createElement("div", {
      style: styles.tireBlockTitle
    }, /*#__PURE__*/React.createElement("div", {
      style: {
        backgroundColor: '#A0A7B7',
        ...styles.tierNumberCircle
      }
    }, /*#__PURE__*/React.createElement(Text, {
      bold: true,
      medium: true,
      color: "#FFFFFF"
    }, "2")), /*#__PURE__*/React.createElement(Text, {
      bold: true,
      large: true
    }, "Silver Tier")), /*#__PURE__*/React.createElement(Healthcare, {
      type: "modular",
      tier: "silver",
      lightTierColor: "#EAEEF2",
      darkTierColor: "#A0A7B7",
      classID: this.props.classID,
      data: blueprint.health.silver.healthcare,
      errors: errors ? errors.health.silver.healthcare : {},
      isMasterSite: isMasterSite,
      saveModularBenefitInitData: saveModularBenefitInitData,
      saveModularField: saveModularField,
      whitelabel: whitelabel,
      setChangesMadeFlag: setChangesMadeFlag
    }), /*#__PURE__*/React.createElement(Drugs, {
      type: "modular",
      tier: "silver",
      lightTierColor: "#EAEEF2",
      darkTierColor: "#A0A7B7",
      classID: this.props.classID,
      data: blueprint.health.silver.drugs,
      errors: errors ? errors.health.silver.drugs : {},
      isMasterSite: isMasterSite,
      saveModularBenefitInitData: saveModularBenefitInitData,
      saveModularField: saveModularField,
      whitelabel: whitelabel,
      setChangesMadeFlag: setChangesMadeFlag
    }), /*#__PURE__*/React.createElement(Dental, {
      type: "modular",
      tier: "silver",
      lightTierColor: "#EAEEF2",
      darkTierColor: "#A0A7B7",
      classID: this.props.classID,
      data: blueprint.dental.silver,
      errors: errors ? errors.dental.silver : {},
      isMasterSite: isMasterSite,
      saveModularBenefitInitData: saveModularBenefitInitData,
      saveModularField: saveModularField,
      whitelabel: whitelabel,
      setChangesMadeFlag: setChangesMadeFlag
    }), /*#__PURE__*/React.createElement(SpendingAccounts, {
      type: "modular",
      tier: "silver",
      lightTierColor: "#EAEEF2",
      darkTierColor: "#A0A7B7",
      classID: this.props.classID,
      data: blueprint.health.silver.spendingAccounts,
      errors: errors ? errors.health.silver.spendingAccounts : {},
      isMasterSite: isMasterSite,
      saveModularBenefitInitData: saveModularBenefitInitData,
      saveModularField: saveModularField,
      whitelabel: whitelabel,
      setChangesMadeFlag: setChangesMadeFlag
    })), /*#__PURE__*/React.createElement("div", {
      style: {
        backgroundColor: '#F9EDE5',
        border: "2px solid #EBCDBA",
        ...styles.tierBlock
      }
    }, /*#__PURE__*/React.createElement("div", {
      style: styles.tireBlockTitle
    }, /*#__PURE__*/React.createElement("div", {
      style: {
        backgroundColor: '#D08D64',
        ...styles.tierNumberCircle
      }
    }, /*#__PURE__*/React.createElement(Text, {
      bold: true,
      medium: true,
      color: "#FFFFFF"
    }, "3")), /*#__PURE__*/React.createElement(Text, {
      bold: true,
      large: true
    }, "Bronze Tier")), /*#__PURE__*/React.createElement(Healthcare, {
      type: "modular",
      tier: "bronze",
      lightTierColor: "#F9EDE5",
      darkTierColor: "#D08D64",
      classID: this.props.classID,
      data: blueprint.health.bronze.healthcare,
      errors: errors ? errors.health.bronze.healthcare : {},
      isMasterSite: isMasterSite,
      saveModularBenefitInitData: saveModularBenefitInitData,
      saveModularField: saveModularField,
      whitelabel: whitelabel,
      setChangesMadeFlag: setChangesMadeFlag
    }), /*#__PURE__*/React.createElement(Drugs, {
      type: "modular",
      tier: "bronze",
      lightTierColor: "#F9EDE5",
      darkTierColor: "#D08D64",
      classID: this.props.classID,
      data: blueprint.health.bronze.drugs,
      errors: errors ? errors.health.bronze.drugs : {},
      isMasterSite: isMasterSite,
      saveModularBenefitInitData: saveModularBenefitInitData,
      saveModularField: saveModularField,
      whitelabel: whitelabel,
      setChangesMadeFlag: setChangesMadeFlag
    }), /*#__PURE__*/React.createElement(Dental, {
      type: "modular",
      tier: "bronze",
      lightTierColor: "#F9EDE5",
      darkTierColor: "#D08D64",
      classID: this.props.classID,
      data: blueprint.dental.bronze,
      errors: errors ? errors.dental.bronze : {},
      isMasterSite: isMasterSite,
      saveModularBenefitInitData: saveModularBenefitInitData,
      saveModularField: saveModularField,
      whitelabel: whitelabel,
      setChangesMadeFlag: setChangesMadeFlag
    }), /*#__PURE__*/React.createElement(SpendingAccounts, {
      type: "modular",
      tier: "bronze",
      lightTierColor: "#F9EDE5",
      darkTierColor: "#D08D64",
      classID: this.props.classID,
      data: blueprint.health.bronze.spendingAccounts,
      errors: errors ? errors.health.bronze.spendingAccounts : {},
      isMasterSite: isMasterSite,
      saveModularBenefitInitData: saveModularBenefitInitData,
      saveModularField: saveModularField,
      whitelabel: whitelabel,
      setChangesMadeFlag: setChangesMadeFlag
    })), /*#__PURE__*/React.createElement(LifeInsurance, {
      type: "modular",
      classID: this.props.classID,
      data: blueprint.lifeInsurance,
      errors: errors ? errors.lifeInsurance : {},
      isMasterSite: isMasterSite,
      saveModularBenefitInitData: saveModularBenefitInitData,
      saveModularField: saveModularField,
      whitelabel: whitelabel,
      setChangesMadeFlag: setChangesMadeFlag
    }), /*#__PURE__*/React.createElement(DeathDismemberment, {
      type: "modular",
      classID: this.props.classID,
      data: blueprint.deathDismemberment,
      errors: errors ? errors.deathDismemberment : {},
      isMasterSite: isMasterSite,
      saveModularBenefitInitData: saveModularBenefitInitData,
      saveModularField: saveModularField,
      whitelabel: whitelabel,
      setChangesMadeFlag: setChangesMadeFlag
    }), /*#__PURE__*/React.createElement(DependentLife, {
      type: "modular",
      classID: this.props.classID,
      data: blueprint.dependentLife,
      errors: errors ? errors.dependentLife : {},
      isMasterSite: isMasterSite,
      saveModularBenefitInitData: saveModularBenefitInitData,
      saveModularField: saveModularField,
      whitelabel: whitelabel,
      setChangesMadeFlag: setChangesMadeFlag
    }), /*#__PURE__*/React.createElement(STD, {
      type: "modular",
      classID: this.props.classID,
      data: blueprint.std,
      errors: errors ? errors.std : {},
      isMasterSite: isMasterSite,
      saveModularBenefitInitData: saveModularBenefitInitData,
      saveModularField: saveModularField,
      whitelabel: whitelabel,
      setChangesMadeFlag: setChangesMadeFlag
    }), /*#__PURE__*/React.createElement(LTD, {
      type: "modular",
      classID: this.props.classID,
      data: blueprint.ltd,
      errors: errors ? errors.ltd : {},
      isMasterSite: isMasterSite,
      saveModularBenefitInitData: saveModularBenefitInitData,
      saveModularField: saveModularField,
      whitelabel: whitelabel,
      setChangesMadeFlag: setChangesMadeFlag
    }), /*#__PURE__*/React.createElement(CriticalIllness, {
      type: "modular",
      classID: this.props.classID,
      data: blueprint.criticalIllness,
      errors: errors ? errors.criticalIllness : {},
      isMasterSite: isMasterSite,
      saveModularBenefitInitData: saveModularBenefitInitData,
      saveModularField: saveModularField,
      whitelabel: whitelabel,
      setChangesMadeFlag: setChangesMadeFlag
    }), /*#__PURE__*/React.createElement(OutOfCountry, {
      type: "modular",
      classID: this.props.classID,
      data: blueprint.outOfCountry || {},
      errors: errors ? errors.outOfCountry : {},
      isMasterSite: isMasterSite,
      saveModularBenefitInitData: saveModularBenefitInitData,
      saveModularField: saveModularField,
      whitelabel: whitelabel,
      setChangesMadeFlag: setChangesMadeFlag
    }), /*#__PURE__*/React.createElement(EFAP, {
      type: "modular",
      classID: this.props.classID,
      data: blueprint.efap || {},
      errors: errors ? errors.efap : {},
      isMasterSite: isMasterSite,
      saveModularBenefitInitData: saveModularBenefitInitData,
      saveModularField: saveModularField,
      whitelabel: whitelabel,
      setChangesMadeFlag: setChangesMadeFlag
    }), /*#__PURE__*/React.createElement(VirtualHealthcare, {
      type: "modular",
      classID: this.props.classID,
      data: blueprint.virtualHealthcare || {},
      errors: errors ? errors.virtualHealthcare : {},
      isMasterSite: isMasterSite,
      saveModularBenefitInitData: saveModularBenefitInitData,
      saveModularField: saveModularField,
      whitelabel: whitelabel,
      setChangesMadeFlag: setChangesMadeFlag
    }), /*#__PURE__*/React.createElement(FinancialAwareness, {
      type: "modular",
      classID: this.props.classID,
      data: blueprint.financialAwareness || {},
      errors: errors ? errors.financialAwareness : {},
      isMasterSite: isMasterSite,
      saveModularBenefitInitData: saveModularBenefitInitData,
      saveModularField: saveModularField,
      whitelabel: whitelabel,
      setChangesMadeFlag: setChangesMadeFlag
    }));
  }
}
export default ModularFlexForm;